import React from "react";

/**
 * SVG icons for each assessment dimension.
 * All icons use a 24×24 viewBox with stroke-based line art.
 */
const icons = {
  /* Foundations — stacked blocks / building base */
  foundations: (
    <>
      <rect x="3" y="15" width="18" height="5" rx="1" />
      <rect x="5" y="9" width="14" height="5" rx="1" />
      <rect x="7" y="3" width="10" height="5" rx="1" />
    </>
  ),

  /* Awareness — eye / lens */
  awareness: (
    <>
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3.5" />
    </>
  ),

  /* Capability — lightning bolt / power */
  capability: (
    <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
  ),

  /* People & Change — two figures */
  people: (
    <>
      <circle cx="9" cy="7" r="3" />
      <path d="M2 20c0-3.3 2.7-6 6-6h2c3.3 0 6 2.7 6 6" />
      <circle cx="17" cy="8" r="2.5" />
      <path d="M22 20c0-2.8-2-5-4.5-5.5" />
    </>
  ),

  /* Vision — compass / north star */
  vision: (
    <>
      <circle cx="12" cy="12" r="9" />
      <polygon points="12,5 13.8,10.2 12,9 10.2,10.2" />
      <polygon points="12,19 13.8,13.8 12,15 10.2,13.8" />
      <polygon points="5,12 10.2,10.2 9,12 10.2,13.8" />
      <polygon points="19,12 13.8,10.2 15,12 13.8,13.8" />
    </>
  ),

  /* Capacity — battery / fuel gauge */
  capacity: (
    <>
      <rect x="3" y="6" width="16" height="12" rx="2" />
      <line x1="21" y1="10" x2="21" y2="14" />
      <rect x="5.5" y="8.5" width="3" height="7" rx="0.5" />
      <rect x="10" y="8.5" width="3" height="7" rx="0.5" />
    </>
  ),

  /* Value Discipline — target / bullseye */
  value: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5.5" />
      <circle cx="12" cy="12" r="2" />
    </>
  ),

  /* Workforce Model — org chart / connected nodes */
  workforce: (
    <>
      <circle cx="12" cy="5" r="2.5" />
      <circle cx="5" cy="18" r="2.5" />
      <circle cx="19" cy="18" r="2.5" />
      <line x1="12" y1="7.5" x2="5" y2="15.5" />
      <line x1="12" y1="7.5" x2="19" y2="15.5" />
    </>
  ),
};

export function DimensionIcon({ dimension, size = 24, color = "currentColor", style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      {icons[dimension]}
    </svg>
  );
}
